// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { Box } from 'grommet'
import { HomeRounded } from 'grommet-icons'
import { useNavigate } from 'react-router-dom'

import { Button, Typography } from '../../../components'

const MainAppData = () => {
  const navigate = useNavigate()
  return (
    <Button testId="app-menu-glcp" onClick={() => navigate('/home')}>
      <Box justify="between" direction="row" margin={{ vertical: 'xsmall' }}>
        <Typography type="text" emphasis>
          HPE GreenLake
        </Typography>
        <HomeRounded />
      </Box>
    </Button>
  )
}

export { MainAppData }
